import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { HOW_IT_WORKS } from "../../../data/sitePages";

export const HowItWorks = () => (
  <section data-testid="how-it-works" className="bg-brand-bg2">
    <div className="mx-auto max-w-[1400px] px-6 py-24 md:px-10 md:py-28">
      <div className="mb-12">
        <p className="overline text-brand-inkSoft">Section 02</p>
        <h2 className="mt-3 font-display text-3xl leading-tight text-brand-ink md:text-5xl">How YogaToYacht works</h2>
      </div>
      <div className="grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-12">
        {HOW_IT_WORKS.map((step, i) => (
          <div key={step.title} data-testid={`how-step-${i}`} className="relative">
            <span className="font-display text-5xl text-brand-terracotta">{String(i + 1).padStart(2, "0")}</span>
            <h3 className="mt-4 font-display text-2xl leading-tight text-brand-ink">{step.title}</h3>
            <p className="mt-3 text-brand-inkSoft">{step.text}</p>
          </div>
        ))}
      </div>
      <Link to="/how-it-works" data-testid="how-it-works-link" className="mt-12 inline-flex items-center gap-2 text-sm font-medium text-brand-ink link-underline">
        Learn how it works <ArrowRight size={15} className="text-brand-terracotta" />
      </Link>
    </div>
  </section>
);

export default HowItWorks;
